import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import Input from '../../../PublicSide/components/Input/Input';
import Button from '../../../PublicSide/components/Button/Button';
import { DefinePassword } from '../../../stores/auth/actions';
import SuccessErrorMessage from '../../components/SuccesErrorMessage/SuccessErrorMessage';
import { StyledContainerLoginPasswordPage, StyledFormLoginPasswordPage } from '../../../style/GlobalsComponentsStyled';
import { HandleError, ShowErrorMessage } from '../../../stores/page/actions';
import ServiceLocator from '../../../services/ServiceLocator';
import { useAppDispatch } from '../../../helpers/UseAppDispatch';
import ErrorCode from '../../../api/dtos/ErrorCode';

const DefinePasswordPage: React.FC = () => {
    const Navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token") || "";

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            setErrorMessage("Please fill in all fields.");
            return;
        }
        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match.");
            return;
        }
        const response = await ServiceLocator.AuthService.InvitePassword({ token, password });

        if (response.is_success) {
            dispatch(DefinePassword());
            Navigate("/login");
        }
        else if (response.error_code === ErrorCode.INVALID_OR_EXPIRED_TOKEN_REGISTRATION) {
            dispatch(ShowErrorMessage(response.error_message ?? 'Token is invalid or has expired. Please ask to receive a new link.'));
        }
        else if (response.error_code === ErrorCode.USER_NOT_FOUND) {
            dispatch(ShowErrorMessage(response.error_message ?? 'User does not exist'));
        }
        else if (response.error_code === ErrorCode.INVALID_FORMAT_PASSWORD) {
            setErrorMessage(response.error_message ?? "The password must be at least 6 characters long, one letter, one number, and one special character.");
        }
        else {
            dispatch(HandleError(response));
        }
    };

    return (
        <StyledContainerLoginPasswordPage as='main'>
            <Typography component='h1' variant='h2'>Define your password</Typography>
            <SuccessErrorMessage errorMessage={errorMessage} onClear={() => { setErrorMessage(''); }} />
            <StyledFormLoginPasswordPage as='form' onSubmit={handleSubmit} noValidate>
                <Input label='Password' type='password' name='password' value={password} onChange={(e) => setPassword(e.target.value)} required />
                <Input label='Confirm Password' type='password' name='confirmPassword' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                <Button type='submit' text='Confirm' />
            </StyledFormLoginPasswordPage>
        </StyledContainerLoginPasswordPage>
    );
};

export default DefinePasswordPage;
